import React,  {useState, useEffect} from "react"

import DiaCalendario from './DiaCalendario';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


import { v1 as uuidv1 } from 'uuid';

function Calendario({handleDia}){

  const [data, setData] = useState([{}])
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  

  let sessionId = ""
  if(localStorage.getItem("sessionId") === null){
    sessionId = uuidv1()
    localStorage.setItem("sessionId", sessionId)
    handleShowModal()
  }else{
    sessionId = localStorage.getItem("sessionId")
  }
  


  

  useEffect(() => {
    fetch("https://www.araquelexplica-te.pt/custom/natal2022/calendario.php").then(
      res => res.json()
    ).then(
      data => {
        setData(data)
      }
    )
  }, [])
  return(
    <div>
      {(typeof data.desafios === 'undefined')? (
        <p>A carregar...</p>
      ):(


        <div class="text-center">
          <div class="row" style={{marginBottom: "10px"}}>
          <div class="col-1"></div>
            <div class="col-2">
              <DiaCalendario dia="1" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="2" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="3" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="4" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="5" handleDia={handleDia}/>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row" style={{marginBottom: "10px"}}>
            <div class="col-1"></div>
            <div class="col-2">
            <DiaCalendario dia="6" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="7" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="8" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="9" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="10" handleDia={handleDia}/>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row" style={{marginBottom: "10px"}}>
            <div class="col-1"></div>
            <div class="col-2">
            <DiaCalendario dia="11" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="12" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="13" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="14" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="15" handleDia={handleDia}/>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row" style={{marginBottom: "10px"}}>
            <div class="col-1"></div>
            <div class="col-2">
            <DiaCalendario dia="16" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="17" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="18" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="19" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="20" handleDia={handleDia}/>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row">
          <div class="col-1"></div>
            <div class="col-2">
            <DiaCalendario dia="21" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="22" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="23" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="24" handleDia={handleDia}/>
            </div>
            <div class="col-2">
            <DiaCalendario dia="25" handleDia={handleDia}/>
            </div>
            <div class="col-1"></div>
          </div>
        </div>


      )}

    <Modal 
    show={showModal} 
    onHide={handleClose}
    centered
    >
        <Modal.Header closeButton>
          <Modal.Title>Bem vindo</Modal.Title>
        </Modal.Header>
        <Modal.Body>Bem vindo ao desafio de Natal de 2022 da Raquel Explica-te.
          Todos os dias vai ficar disponível um novo desafio para resolveres.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Começar o desafio
          </Button>
        </Modal.Footer>
        </Modal>
    </div>
  )
}

export default Calendario